// Per venue-type visual accents (gradient band, icon, chip tint) shared by the
// venue picker cards and the event preview/invite card.
import { FiCalendar } from 'react-icons/fi';
import { GiGolfFlag } from 'react-icons/gi';
import { Beer, Wine, Martini, FlaskConical, UtensilsCrossed, Palette } from 'lucide-react';

export const TYPE_META = {
  Golf:           { gradient: 'linear(135deg, #1f5e3a, #2f8f57)', icon: GiGolfFlag,      tint: 'rgba(122,226,161,0.95)', bg: 'rgba(122,226,161,0.12)', border: 'rgba(122,226,161,0.24)' },
  Brewery:        { gradient: 'linear(135deg, #7c4a13, #c98a2e)', icon: Beer,            tint: 'rgba(251,191,36,0.95)',  bg: 'rgba(251,191,36,0.12)',  border: 'rgba(251,191,36,0.24)' },
  Distillery:     { gradient: 'linear(135deg, #5b3a1e, #a9743f)', icon: FlaskConical,    tint: 'rgba(234,179,8,0.95)',   bg: 'rgba(234,179,8,0.12)',   border: 'rgba(234,179,8,0.24)' },
  'Cocktail Bar': { gradient: 'linear(135deg, #4a2150, #8e3b86)', icon: Martini,         tint: 'rgba(216,180,254,0.95)', bg: 'rgba(216,180,254,0.12)', border: 'rgba(216,180,254,0.24)' },
  Restaurant:     { gradient: 'linear(135deg, #5b1f24, #a23f47)', icon: UtensilsCrossed, tint: 'rgba(252,165,165,0.95)', bg: 'rgba(252,165,165,0.12)', border: 'rgba(252,165,165,0.24)' },
  Pottery:        { gradient: 'linear(135deg, #6b3a26, #b5673f)', icon: Palette,         tint: 'rgba(253,186,116,0.95)', bg: 'rgba(253,186,116,0.12)', border: 'rgba(253,186,116,0.24)' },
  Winery:         { gradient: 'linear(135deg, #4a1226, #8a2741)', icon: Wine,            tint: 'rgba(244,114,182,0.95)', bg: 'rgba(244,114,182,0.12)', border: 'rgba(244,114,182,0.24)' },
};

export const PREVIEW_FALLBACK = {
  gradient: 'linear(135deg, #312e6b, #16213e)',
  tint: 'rgba(167,139,250,0.95)',
  icon: FiCalendar,
};
